import React, { useState }  from "react";
import { GraphUp } from 'react-bootstrap-icons';
import ModalComp from "./ModalComp"

const UnatedDataTable = (props) => {
  const {data_10_days_back, t_get_sensor_data_30m_by_selectedDevId_sensorId_for_modal, update_sensor_collections, 
    isModal, modalTitle, sensor_data_for_modal} = props;

  //const [modalTitle, setModalTitle] = useState("");

 /*  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false); */

  if (data_10_days_back.dev_id_with_name.length === 0) return <></>




  //console.log(data_10_days_back.dev_id_with_name.length)

  //{id: 3, date: '2024-12-04', t2: 25, h2: 25, t3: 25, …}
  const handleClick = (e, item) => {
    const iDate = item.date
    //get only number from dev_id code
    const dev_id = e.match(/\d+/g)[0];
    //get data by particulary dev_id by date
    //console.log("clicked: ", dev_id, iDate)
    t_get_sensor_data_30m_by_selectedDevId_sensorId_for_modal(dev_id, iDate)
    update_sensor_collections("modalTitle", `Date: ${iDate} by 30 min step`);
    update_sensor_collections("isModal", true);
    
  }

  const valueDecorate = (v) => {
    if (/^h\d+$/.test(v[0]))  return "text-primary" //looking for h2...
    if (v[0].includes("date")) return "text-info"
    if (v[0].includes("id")) return "text-secondary"

    return "text-secondary"
  }

  const valueContent = (v, item) => {
    //console.log(v)
    if (/^h\d+$/.test(v[0])) {
      if (!v[1]) return '-'

      return <>{`${v[1]+" "}`}<GraphUp onClick={()=> {handleClick(v[0], item)}}/></>

    }
    return v[1]?v[1]:'-'
  }

  return (
    <>
    <hr />
    <h5>Sensors Data Within 10 Days</h5>
    <table className="table table-striped">
    <thead>
      <tr className="text-secondary">
        {Object.entries(data_10_days_back.union_data[0]).map((el,i) => <th key={i}>{el[0]}</th>)}
      </tr>
    </thead>
    <tbody>
        {data_10_days_back.union_data.map((item) => (
            <tr key={item.id}>
                {Object.entries(item).map((v,i) => <td key={i} className={valueDecorate(v)}>{valueContent(v, item)}</td>)}
            </tr>
        ))}
    </tbody>
    </table>

    <div>
    <ModalComp 
     title={"Title Hello"} 
     body={"Body Hello"}
     update_sensor_collections = {update_sensor_collections}
     isModal={isModal}
     modalTitle = {modalTitle}
     sensor_data_for_modal = {sensor_data_for_modal}
    />



    </div>
    </>
  )
}

export default UnatedDataTable